import React, { useMemo, useState } from 'react';
import { getFilterOptions } from '../../data/vehicles';
import { useVehicles } from '../../context/VehiclesContext';
import { IconSearch } from '../ui/Icons';

const SearchForm = ({ onSearch }) => {
  const { vehicles } = useVehicles();
  const filterOptions = useMemo(() => getFilterOptions(vehicles), [vehicles]);

  const [filters, setFilters] = useState({
    make: '',
    bodyType: '',
    year: '',
    price: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSearch) {
      onSearch(filters);
    }
  };

  return (
    <section className="search-section">
      <div className="container">
        <form className="search-container" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="make">Make</label>
            <select 
              id="make" 
              name="make" 
              value={filters.make} 
              onChange={handleChange}
            >
              <option value="">All Makes</option>
              {filterOptions.makes.map(make => (
                <option key={make} value={make}>{make}</option>
              ))}
            </select>
          </div>
          
          <div className="form-group">
            <label htmlFor="bodyType">Body Type</label>
            <select 
              id="bodyType" 
              name="bodyType" 
              value={filters.bodyType} 
              onChange={handleChange}
            >
              <option value="">All Types</option>
              {filterOptions.bodyTypes.map(type => (
                <option key={type} value={type}>{type}</option>
              ))}
            </select>
          </div>
          
          <div className="form-group">
            <label htmlFor="year">Year</label>
            <select 
              id="year" 
              name="year" 
              value={filters.year} 
              onChange={handleChange}
            >
              <option value="">All Years</option>
              {filterOptions.years.map(year => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
          </div>
          
          <div className="form-group">
            <label htmlFor="price">Price Range</label>
            <select 
              id="price" 
              name="price" 
              value={filters.price} 
              onChange={handleChange}
            >
              <option value="">Any Price</option>
              {filterOptions.priceRanges.map(range => (
                <option key={range.value} value={range.value}>
                  {range.label}
                </option>
              ))}
            </select>
          </div>
          
          <button type="submit" className="search-btn">
            <IconSearch /> Search
          </button>
        </form>
      </div>
    </section>
  );
};

export default SearchForm;
